import { CircleDashed, PlusIcon } from "lucide-react";
import React from "react";
import { Button } from "../ui/button";
import { KanbanDefaultStates } from "./CanvasKanban";

const NoIssues = ({
  handleButtonClick,
}: {
  handleButtonClick: (key: KanbanDefaultStates) => void;
}) => {
  return (
    <div className="flex flex-col items-center justify-center h-[calc(100vh-140px)] gap-4 shrink-0">
      <CircleDashed size={40} className="text-icons-primary" strokeWidth={1} />
      <h3 className="text-text-secondary text-lg">No canvases found</h3>
      <Button
        variant="primary"
        size="sm"
        className="px-2 gap-1 text-xs"
        onClick={() => handleButtonClick(KanbanDefaultStates.BACKLOG)}
      >
        <PlusIcon size={14} /> Canvas
      </Button>
    </div>
  );
};

export default React.memo(NoIssues);
